import { defineStore } from 'pinia';

export const useNavStore = defineStore('nav', {
  state () {
    return {
      mode: 'buy' as 'buy' | 'rent',
      previousUrl: '' as string
    }
  },
  getters: {
    backButtonLabel: (state): string => {
      const prev = state.previousUrl || (typeof document !== 'undefined' ? document.referrer : '');
      if (!prev) return 'property.back_to_search';

      try {
        const url = new URL(prev);
        if (url.pathname.endsWith('/search')) {
          return 'property.back_to_search';
        }
        if (url.pathname.includes('/property/')) {
          return 'property.back';
        }
        if (url.pathname === '/' || url.pathname === '/en' || url.pathname === '/ja') {
          return 'property.back_to_home';
        }
        return 'property.back_to_list';
      } catch (e) {
        return 'property.back_to_search';
      }
    }
  },
  actions: {
    setMode(mode: 'buy' | 'rent') {
      this.mode = mode
      if (typeof document !== 'undefined') {
        document.cookie = `openroom-nav-mode=${mode}; path=/; max-age=31536000`; // 1 year
      }
    },
    setPreviousUrl(url: string) {
      this.previousUrl = url
    }
  },
});
